import { ApplicationController, useThrottle } from 'stimulus-use'
import { log } from "../../javascript/utils/logger"

export default class extends ApplicationController {
  static throttles = ['onMapChange']

  connect() {
    useThrottle(this, { wait: 1000 })

    log("advocate card list connect")
  }

  disconnect() {
    log("advocate card list disconnect")
  }

  onMapChange(event) {
    log("update from map change!", event)
    if (event.detail && event.detail.center) {
      const { lat, lng } = event.detail.center
      const { zoom } = event.detail

      // Preserve existing query parameters (like tags, match_mode) from current src
      const currentSrc = this.element.src
      const url = new URL(currentSrc, window.location.origin)
      const existingParams = new URLSearchParams(url.search)

      // Update lat/lng/zoom
      existingParams.set('lat', lat)
      existingParams.set('lng', lng)
      if (zoom != null) existingParams.set('zoom', zoom)

      // Build new URL with preserved params
      const newUrl = `/advocates?${existingParams.toString()}`
      this.element.src = newUrl
    }
  }
}
